export const GET_TRIP_FIELDS_REQUEST = 'GET_TRIP_FIELDS_REQUEST' as const;
export const GET_TRIP_FIELDS_SUCCESS = 'GET_TRIP_FIELDS_SUCCESS' as const;
export const GET_TRIP_FIELDS_ERROR = 'GET_TRIP_FIELDS_ERROR' as const;

export const GET_ORDER_WEIGHT_REQUEST = 'GET_ORDER_WEIGHT_REQUEST' as const;
export const GET_ORDER_WEIGHT_SUCCESS = 'GET_ORDER_WEIGHT_SUCCESS' as const;
export const GET_ORDER_WEIGHT_ERROR = 'GET_ORDER_WEIGHT_ERROR' as const;

export const GET_TRIP_ORDERS_REQUEST = 'GET_TRIP_ORDERS_REQUEST' as const;
export const GET_TRIP_ORDERS_ERROR = 'GET_TRIP_ORDERS_ERROR' as const;
export const GET_TRIP_ORDERS_SUCCESS = 'GET_TRIP_ORDERS_SUCCESS' as const;
export const GET_ORDER_PART_NUM_REQUEST = 'GET_ORDER_PART_NUM_REQUEST' as const;

export const CLEAN_TRIP_FIELDS_LOADED = 'CLEAN_TRIP_FIELDS_LOADED' as const;
export const GET_REQDOC_ERROR = 'GET_REQDOC_ERROR' as const;

export const SET_TRIP_FIELDS = 'SET_TRIP_FIELDS' as const;

export const CLEAR_ERROR = 'CLEAR_ERROR' as const;
